<template>
    <div>

        <div>
            <FileUploader
                id="piece-identite"
                title="<strong>Carte nationale d'identité, passeport ou carte consulaire recto/verso*</strong>"
                :nbFiles="{ min: 1, max: 2 }"
                @onState="setPieceIdentiteState"
                />
        </div>

        <div class="mt-4">
            <FileUploader
                id="attestation-bancaire"
                title="Relevé ou attestation bancaire à votre nom mentionnant l'IBAN"
                :nbFiles="{ min: 0, max: 2 }"
                />
        </div>

        <div class="mt-4">
            <FileUploader
                id="notification-retraite"
                title="Notification de retraite (personnelle ou de réversion)"
                :nbFiles="{ min: 0, max: 2 }"
                />
        </div>

        <BackNext
            :buttons="buttons"/>

    </div>
</template>

<script>
import FileUploader from '@/components/FileUploader'
import BackNext from '@/components/BackNext'

export default {
  name: 'PiecesAJoindre',
  components: {
    FileUploader,
    BackNext
  },
  mounted() {

    // Renvoi vers l'URL du site
    if (this.$store.endOfInscription || !this.$actions.getStepChecked('accueil') || !this.$actions.getStepChecked('identite') || !this.$actions.getStepChecked('coordonnees') || !this.$actions.getStepChecked('regulariteDeSejour')) {
        window.location = this.$config.SITE
    }

    // Envoi un évenement onSetStepper pour mettre a jour l'étape
    this.$emit('onSetStepper', 'piecesAJoindre');
  },
  computed: {
    buttons: function() {
        return {
            routes: {
                back: 'RegulariteDeSejour',
                next: 'Validation'
            },
            next: this.$actions.getStepChecked('accueil') && this.$actions.getStepChecked('identite') && this.$actions.getStepChecked('coordonnees') && this.$actions.getStepChecked('regulariteDeSejour') && this.$actions.getStepChecked('piecesAJoindre')
        }
    }
  },
  methods: {
      setPieceIdentiteState(val) {
            this.$actions.setStepChecked('piecesAJoindre', val);
      }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PiecesAJoindre.vue